import PropTypes from "prop-types";
import classNames from "classnames";

const FilterIcon = ({ className, size = 16, fill = "currentColor", ...props }) => {
	const filterIconClassName = classNames("filter-icon", className);

	return (
		<svg
			width={size}
			height={size}
			viewBox="0 0 16 16"
			fill="none"
			xmlns="http://www.w3.org/2000/svg"
			className={filterIconClassName}
			{...props}
		>
			<path
				fill={fill}
				d="M14.1005 1.8667H1.96719C1.63385 1.8667 1.36719 2.13337 1.36719 2.4667V4.2667C1.36719 4.40003 1.36719 4.4667 1.50052 4.60003L5.70052 7.73337H5.76719C5.96719 8.00003 6.10052 8.2667 6.10052 8.53336L6.70052 13.8C6.70052 13.9334 6.76719 14.0667 6.90052 14.1334C6.90052 14.1334 7.03385 14.1334 7.10052 14.1334C7.16719 14.1334 7.23385 14.1334 7.30052 14.1334L9.03385 13.2667C9.16719 13.2667 9.23385 13.0667 9.23385 13L9.90052 8.53336C9.90052 8.2667 10.1005 8.00003 10.3005 7.80003L14.5005 4.6667C14.5672 4.60003 14.6339 4.4667 14.6339 4.33337V2.53337C14.6339 2.20003 14.3672 1.93337 14.0339 1.93337L14.1005 1.8667Z"
			/>
		</svg>
	);
};

FilterIcon.propTypes = {
	className: PropTypes.string,
	fill: PropTypes.string,
	size: PropTypes.number,
};

export default FilterIcon;
